import { fundingSourceApi } from "api/immunization";
import MasterListScreen from "./common/MasterListScreen";
import FundingSourceModal from "./FundingSourceModal";

const FundingSourceList = ({ searchText = "" }) => (
  <MasterListScreen
    resource={fundingSourceApi}
    label="Funding source"
    entityLabel="funding source"
    addLabel="Add Funding Source"
    tag="immunization-funding-source"
    headers={[
      "Name",
      "Code",
      "Free",
      "Govt Reportable",
      "Scheme Ref",
      "Status",
      "Action",
    ]}
    keys={[
      "name",
      "code",
      "freeLabel",
      "reportableLabel",
      "schemeLabel",
      "statusChip",
      "action",
    ]}
    displayName={(item) => item.display}
    mapRow={(item) => ({
      freeLabel: item.isFree ? "Yes" : "No",
      reportableLabel: item.governmentReportable ? "Yes" : "No",
      schemeLabel: item.requiresSchemeReference ? "Required" : "—",
    })}
    Modal={FundingSourceModal}
    searchText={searchText}
  />
);

export default FundingSourceList;
